const HIPOTEKATIPAS = {
  // sutartine hipoteka
  'sutartinis-hipoteka-sandoris': {
    button: 'Sudaryti sutartinę hipoteką',
    title: 'Sutartinė hipoteka',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-sandoris-teikiamas': {
    button: 'Sudaryti sutartinę hipoteką',
    title: 'Sutartinė hipoteka',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-pakeitimas': {
    button: 'Keisti sutartinę hipoteką',
    title: 'Sutartinės hipotekos pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-pakeitimas-teikiamas': {
    button: 'Keisti sutartinę hipoteką',
    title: 'Sutartinės hipotekos pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-pakeitimas-adresas': {
    button: 'Keisti sutartinės hipotekos adresus',
    title: 'Pakeitimas dėl adresų keitimo',
    role: ['DT_JA'],
  },
  'sutartinis-hipoteka-pabaiga': {
    button: 'Baigti sutartinę hipoteką',
    title: 'Sutartinės hipotekos pabaiga',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-isigaliojimas': {
    button: 'Registruoti sutartinės hipotekos sąlygos įsigaliojimą',
    title: 'Sutartinės hipotekos sąlygos įsigaliojimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-archyvas': {
    button: 'Atstatyti sutartinę hipoteką iš archyvo',
    title: 'Sutartinės hipotekos atstatymas iš archyvo',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_kita_institucija',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  // sutartinis ikeitimas
  'sutartinis-ikeitimas-sandoris': {
    button: 'Sudaryti sutartinį įkeitimą',
    title: 'Sutartinis įkeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-sandoris-teikiamas': {
    button: 'Sudaryti sutartinį įkeitimą',
    title: 'Sutartinis įkeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-pakeitimas': {
    button: 'Keisti sutartinį įkeitimą',
    title: 'Sutartinio įkeitimo pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-pakeitimas-teikiamas': {
    button: 'Keisti sutartinį įkeitimą',
    title: 'Sutartinio įkeitimo pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-pakeitimas-adresas': {
    button: 'Keisti sutartinio įkeitimo adresus',
    title: 'Pakeitimas dėl adresų keitimo',
    role: ['DT_JA'],
  },
  'sutartinis-ikeitimas-pabaiga': {
    button: 'Baigti sutartinį įkeitimą',
    title: 'Sutartinio įkeitimo pabaiga',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-isigaliojimas': {
    button: 'Registruoti sutartinio įkeitimo sąlygos įsigaliojimą',
    title: 'Sutartinio įkeitimo sąlygos įsigaliojimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-archyvas': {
    button: 'Atstatyti sutartinį įkeitimą iš archyvo',
    title: 'Sutartinio įkeitimo atstatymas iš archyvo',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_kita_institucija',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  // priverstine hipoteka
  'priverstinis-hipoteka-nustatymas': {
    button: 'Sukurti priverstinės hipotekos nustatymą',
    title: 'Priverstinės hipotekos nustatymas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_kita_institucija',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-hipoteka-pakeitimas': {
    button: 'Keisti priverstinę hipoteką',
    title: 'Priverstinės hipotekos pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_antstolis',
      'DT_kita_institucija',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-hipoteka-pakeitimas-adresas': {
    button: 'Keisti priverstinės hipotekos adresus',
    title: 'Pakeitimas dėl adresų keitimo',
    role: ['DT_JA'],
  },
  'priverstinis-hipoteka-pabaiga': {
    button: 'Baigti priverstinę hipoteką',
    title: 'Priverstinės hipotekos pabaiga',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_antstolis',
      'DT_kita_institucija',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-hipoteka-archyvas': {
    button: 'Atstatyti priverstinę hipoteką iš archyvo',
    title: 'Priverstinės hipotekos atstatymas iš archyvo',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_kita_institucija',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  //priverstinis ikeitimas
  'priverstinis-ikeitimas-nustatymas': {
    button: 'Sukurti priverstinio įkeitimo nustatymą',
    title: 'Priverstinio įkeitimo nustatymas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_kita_institucija',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-ikeitimas-pakeitimas': {
    button: 'Keisti priverstinį įkeitimą',
    title: 'Priverstinio įkeitimo pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_antstolis',
      'DT_kita_institucija',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-ikeitimas-pakeitimas-adresas': {
    button: 'Keisti priverstinio įkeitimo adresus',
    title: 'Pakeitimas dėl adresų keitimo',
    role: ['DT_JA'],
  },
  'priverstinis-ikeitimas-pabaiga': {
    button: 'Baigti priverstinį įkeitimą',
    title: 'Priverstinio įkeitimo pabaiga',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_antstolis',
      'DT_kita_institucija',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-ikeitimas-archyvas': {
    button: 'Atstatyti priverstinį įkeitimą iš archyvo',
    title: 'Priverstinio įkeitimo atstatymas iš archyvo',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'DT_antstolis',
      'DT_kita_institucija',
      'DT_JA',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  // vykdomasis irasas
  'sutartinis-hipoteka-vykdomasis-atlikimas': {
    button: 'Įrašyti sutartinės hipotekos notaro vykdomojo įrašo atlikimą',
    title: 'Sutartinės hipotekos notaro vykdomojo įrašo atlikimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-vykdomasis-atlikimas-teikiamas': {
    button: 'Įrašyti sutartinės hipotekos notaro vykdomojo įrašo atlikimą',
    title: 'Sutartinės hipotekos atlikto notaro vykdomojo įrašo teikimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-vykdomasis-pakeitimas': {
    button: 'Pakeisti sutartinės hipotekos notaro vykdomąjį įrašą',
    title: 'Sutartinės hipotekos notaro vykdomojo įrašo pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-hipoteka-vykdomasis-panaikinimas': {
    button: 'Naikinti sutartinės hipotekos notaro vykdomąjį įrašą',
    title: 'Sutartinės hipotekos notaro vykdomojo įrašo naikinimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  'sutartinis-ikeitimas-vykdomasis-atlikimas': {
    button: 'Įrašyti sutartinio įkeitimo notaro vykdomojo įrašo atlikimą',
    title: 'Sutartinio įkeitimo notaro vykdomojo įrašo atlikimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-vykdomasis-atlikimas-teikiamas': {
    button: 'Įrašyti sutartinio įkeitimo notaro vykdomojo įrašo atlikimą',
    title: 'Sutartinio įkeitimo atlikto notaro vykdomojo įrašo teikimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-vykdomasis-pakeitimas': {
    button: 'Pakeisti sutartinio įkeitimo notaro vykdomąjį įrašą',
    title: 'Sutartinio įkeitimo notaro vykdomojo įrašo pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'sutartinis-ikeitimas-vykdomasis-panaikinimas': {
    button: 'Naikinti sutartinio įkeitimo notaro vykdomąjį įrašą',
    title: 'Sutartinio įkeitimo notaro vykdomojo įrašo naikinimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  'priverstinis-hipoteka-vykdomasis-atlikimas': {
    button: 'Įrašyti priverstinės hipotekos notaro vykdomojo įrašo atlikimą',
    title: 'Priverstinės hipotekos notaro vykdomojo įrašo atlikimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-hipoteka-vykdomasis-pakeitimas': {
    button: 'Pakeisti priverstinės hipotekos notaro vykdomąjį įrašą',
    title: 'Priverstinės hipotekos notaro vykdomojo įrašo pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-hipoteka-vykdomasis-panaikinimas': {
    button: 'Naikinti priverstinės hipotekos notaro vykdomąjį įrašą',
    title: 'Priverstinės hipotekos notaro vykdomojo įrašo naikinimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  'priverstinis-ikeitimas-vykdomasis-atlikimas': {
    button: 'Įrašyti priverstinio įkeitimo notaro vykdomojo įrašo atlikimą',
    title: 'Priverstinio įkeitimo notaro vykdomojo įrašo atlikimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-ikeitimas-vykdomasis-pakeitimas': {
    button: 'Pakeisti priverstinio įkeitimo notaro vykdomąjį įrašą',
    title: 'Priverstinio įkeitimo notaro vykdomojo įrašo pakeitimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },
  'priverstinis-ikeitimas-vykdomasis-panaikinimas': {
    button: 'Naikinti priverstinio įkeitimo notaro vykdomąjį įrašą',
    title: 'Priverstinio įkeitimo notaro vykdomojo įrašo naikinimas',
    role: [
      'DT_notaras',
      'DT_notaro_padejejas',
      'DT_notaro_atstovas',
      'DT_teismas',
      'RG_STSR_registrat',
      'RG_NTR_registrat',
      'RG_NTR_vadovas',
    ],
  },

  // ----------------------  Sutartis -----------------------------
  // atpirkimas
  'sutartis-atpirkimas-teikimas': {
    title: 'Pirkimo – pardavimo su atpirkimo teise sutarties teikimas',
    button: 'Teikti sutarties duomenis',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-atpirkimas-pakeitimas': {
    title: 'Pirkimo – pardavimo su atpirkimo teise sutarties pakeitimas',
    button: 'Keisti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-atpirkimas-pabaiga': {
    title: 'Pirkimo – pardavimo su atpirkimo teise sutarties pabaiga',
    button: 'Baigti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-atpirkimas-neisregistruoti': {
    title:
      'Pirkimo – pardavimo su atpirkimo teise sutarties prašymas neišregistruoti automatiškai',
    button: 'Prašyti neišregistruoti sutarties automatiškai',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-atpirkimas-pageidavimas': {
    title:
      'Pirkimo – pardavimo su atpirkimo teise sutarties pageidavimas pasinaudoti atpirkimo teise',
    button: 'Pageidauti pasinaudoti atpirkimo teise',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-atpirkimas-atsaukimas': {
    title:
      'Pirkimo – pardavimo su atpirkimo teise sutarties pageidavimo pasinaudoti atpirkimo teise atšaukimas',
    button: 'Atšaukti pageidavimą pasinaudoti atpirkimo teise',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },

  // issimoketinas
  'sutartis-issimoketinas-teikimas': {
    title: 'Pirkimo - pardavimo išsimokėtinai sutarties teikimas',
    button: 'Teikti sutarties duomenis',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-issimoketinas-pakeitimas': {
    title: 'Pirkimo - pardavimo išsimokėtinai sutarties pakeitimas',
    button: 'Keisti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-issimoketinas-pabaiga': {
    title: 'Pirkimo - pardavimo išsimokėtinai sutarties pabaiga',
    button: 'Baigti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-issimoketinas-neisregistruoti': {
    title:
      'Pirkimo - pardavimo išsimokėtinai sutarties prašymas neišregistruoti automatiškai',
    button: 'Prašyti neišregistruoti sutarties automatiškai',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },

  // lizingas
  'sutartis-lizingas-teikimas': {
    title: 'Lizingo (finansinės nuomos) sutarties teikimas',
    button: 'Teikti sutarties duomenis',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-lizingas-pakeitimas': {
    title: 'Lizingo (finansinės nuomos) sutarties pakeitimas',
    button: 'Keisti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-lizingas-pabaiga': {
    title: 'Lizingo (finansinės nuomos) sutarties pabaiga',
    button: 'Baigti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-lizingas-neisregistruoti': {
    title:
      'Lizingo (finansinės nuomos) sutarties prašymas neišregistruoti automatiškai',
    button: 'Prašyti neišregistruoti sutarties automatiškai',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },

  // nuoma
  'sutartis-nuoma-teikimas': {
    title: 'Neregistruojamų daiktų nuomos sutarties teikimas',
    button: 'Teikti sutarties duomenis',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-nuoma-pakeitimas': {
    title: 'Neregistruojamų daiktų nuomos sutarties pakeitimas',
    button: 'Keisti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-nuoma-pabaiga': {
    title: 'Neregistruojamų daiktų nuomos sutarties pabaiga',
    button: 'Baigti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-nuoma-neisregistruoti': {
    title:
      'Neregistruojamų daiktų nuomos  sutarties prašymas neišregistruoti automatiškai',
    button: 'Prašyti neišregistruoti sutarties automatiškai',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },

  // panauda
  'sutartis-panauda-teikimas': {
    title: 'Neregistruojamų daiktų panaudos sutarties teikimas',
    button: 'Teikti sutarties duomenis',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-panauda-pakeitimas': {
    title: 'Neregistruojamų daiktų panaudos sutarties pakeitimas',
    button: 'Keisti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-panauda-pabaiga': {
    title: 'Neregistruojamų daiktų panaudos sutarties pabaiga',
    button: 'Baigti sutartį',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
  'sutartis-panauda-neisregistruoti': {
    title:
      'Neregistruojamų daiktų panaudos sutarties prašymas neišregistruoti automatiškai',
    button: 'Prašyti neišregistruoti sutarties automatiškai',
    role: ['DT_JA', 'RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],
  },
}

const PRANESIMASRUSIS = {
  'sutartinis-ikeitimas': {
    title: 'Sutartinio įkeitimo rūšys',
    labels: {
      maksimalus: 'Maksimalusis įkeitimas',
      paprastas: 'Paprastasis įkeitimas',
      jungtinis: 'Jungtinis įkeitimas',
      svetimas: 'Svetimo turto įkeitimas',
      bendras: 'Bendrasis įkeitimas',
      imones: 'Įmonės įkeitimas',
      salyginis: 'Sąlyginis įkeitimas',
      pareikstinis: 'Pareikštinis įkeitimas',

      maksimalusTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Maksimalusis įkeitimas',
      paprastasTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Paprastasis įkeitimas',
      jungtinisTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Jungtinis įkeitimas',
      svetimasTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Svetimo turto įkeitimas',
      bendrasTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Bendrasis įkeitimas',
      imonesTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Įmonės įkeitimas',
      salyginisTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Sąlyginis įkeitimas',
      pareikstinisTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinis įkeitimas. Pareikštinis įkeitimas',
    },
  },
  'sutartinis-hipoteka': {
    title: 'Sutartinės hipotekos rūšys',
    labels: {
      maksimalus: 'Maksimalioji hipoteka',
      paprastas: 'Paprastoji hipoteka',
      jungtinis: 'Jungtinė hipoteka',
      svetimas: 'Svetimo daikto hipoteka',
      bendras: 'Bendroji hipoteka',
      imones: 'Įmonės hipoteka',
      salyginis: 'Sąlyginė hipoteka',
      pareikstinis: 'Pareikštinė hipoteka',

      maksimalusTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Maksimalioji hipoteka',
      paprastasTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Paprastoji hipoteka',
      jungtinisTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Jungtinė hipoteka',
      svetimasTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Svetimo daikto hipoteka',
      bendrasTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Bendroji hipoteka',
      imonesTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Įmonės hipoteka',
      salyginisTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Sąlyginė hipoteka',
      pareikstinisTooltip:
        'Hipoteka. Dokumentas. Rūšis. Sutartinė hipoteka. Pareikštinė hipoteka',
    },
  },
}

const PRANESIMASPAGRINDAS = {
  pakeitimas: {
    sutartinis: {
      pagrindas: 'Pakeitimo pagrindas',
      aprasymas: 'Pakeitimo pagrindo aprašymas',
      data: 'Sandorio pakeitimo data',
      laikas: 'Sandorio pakeitimo laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Sutartinis. Pakeitimas. ',
    },
    priverstinis: {
      pagrindas: 'Pakeitimo pagrindas',
      aprasymas: 'Pakeitimo pagrindo aprašymas',
      data: 'Pakeitimo nustatymo data',
      laikas: 'Pakeitimo nustatymo laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Priverstinis. Pakeitimas. ',
    },
    sutartis: {
      pagrindas: 'Pakeitimo pagrindas',
      aprasymas: 'Pakeitimo pagrindo aprašymas',
      data: 'Sutarties pakeitimo įregistravimo data',
      laikas: 'Sutarties pakeitimo įregistravimo laikas',
      tooltipPrefix: 'Sutartis. Dokumentas. Sutartis pakeitimas. ',
    },
  },
  isigaliojimas: {
    sutartinis: {
      pagrindas: 'Pakeitimo pagrindas',
      aprasymas: 'Pakeitimo pagrindo aprašymas',
      data: 'Sandorio pakeitimo data',
      laikas: 'Sandorio pakeitimo laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Hipoteka. Sąlygos įsigaliojimas. ',
    },
    priverstinis: {
      pagrindas: 'Pakeitimo pagrindas',
      aprasymas: 'Pakeitimo pagrindo aprašymas',
      data: 'Pakeitimo nustatymo data',
      laikas: 'Pakeitimo nustatymo laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Įkeitimas. Sąlygos įsigaliojimas. ',
    },
  },
  pabaiga: {
    sutartinis: {
      pagrindas: 'Išregistravimo pagrindas',
      aprasymas: 'Išregistravimo pagrindo aprašymas',
      data: 'Sandorio pabaigos data',
      laikas: 'Sandorio pabaigos laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Sutartinis. Pabaiga. ',
    },
    priverstinis: {
      pagrindas: 'Išregistravimo pagrindas',
      aprasymas: 'Išregistravimo pagrindo aprašymas',
      data: 'Pabaigos nustatymo data',
      laikas: 'Pabaigos nustatymo laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Priverstinis. Pabaiga. ',
    },
    sutartis: {
      pagrindas: 'Sutarties išregistravimo pagrindas',
      aprasymas: 'Išregistravimo pagrindo aprašymas',
      data: 'Sutarties išregistravimo data',
      laikas: 'Sutarties išregistravimo laikas',
      tooltipPrefix: 'Sutartis. Dokumentas. Sutartis pabaiga. ',
    },
  },
  panaikinimas: {
    sutartinis: {
      pagrindas: 'Išregistravimo pagrindas',
      aprasymas: 'Išregistravimo pagrindo aprašymas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Sutartinis. NVI panaikinimas. ',
    },
    priverstinis: {
      pagrindas: 'Išregistravimo pagrindas',
      aprasymas: 'Išregistravimo pagrindo aprašymas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Priverstinis. NVI panaikinimas. ',
    },
  },
  pageidavimas: {
    sutartis: {
      pagrindas: 'Pakeitimo pagrindas',
      aprasymas: 'Pakeitimo pagrindo aprašymas',
      tooltipPrefix: 'Sutartis. Dokumentas. Pageidavimas. ',
    },
  },
  atsaukimas: {
    sutartis: {
      pagrindas: 'Pakeitimo pagrindas',
      aprasymas: 'Pakeitimo pagrindo aprašymas',
      tooltipPrefix: 'Sutartis. Dokumentas. Pageidavimo atšaukimas. ',
    },
  },
  archyvas: {
    sutartinis: {
      pagrindas: 'Atstatymo iš archyvo pagrindas',
      aprasymas: 'Atstatymo iš archyvo pagrindo aprašymas',
      data: 'Atstatymo iš archyvo data',
      laikas: 'Atstatymo iš archyvo laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Sutartinis. Archyvas. ',
    },
    priverstinis: {
      pagrindas: 'Atstatymo iš archyvo pagrindas',
      aprasymas: 'Atstatymo iš archyvo pagrindo aprašymas',
      data: 'Atstatymo iš archyvo data',
      laikas: 'Atstatymo iš archyvo laikas',
      tooltipPrefix: 'Hipoteka. Dokumentas. Priverstinis. Archyvas. ',
    },
  },
}

const TURTASTEKSTAS = {
  ikeitimas: {
    title: 'Įkeitimo objektai',
    bendra_verte: 'Bendra įkeitimo objektų vertė, EUR',
    bendra_verteTooltip: 'Hipoteka. Turtas. Bendra įkeitimo objektų vertė',
  },
  hipoteka: {
    title: 'Hipotekos objektai',
    bendra_verte: 'Bendra hipotekos objektų vertė, EUR',
    bendra_verteTooltip: 'Hipoteka. Turtas. Bendra hipotekos objektų vertė',
  },
}

const TURTASKITASTITLE = {
  ikeitimas: {
    title: 'Kita',
  },
  hipoteka: {
    title: 'Kita',
  },
}

const TURTASREFRESHTABLE = 5000
const TurtasRefreshDefault = 3000

const TURTASTIPAS = {
  orlaivis: {
    key: 'orlaivis',
    title: 'Orlaivis',
    refresh: TurtasRefreshDefault,
  },
  juru_laivas: {
    key: 'juru_laivas',
    title: 'Jūrų laivas',
    refresh: TurtasRefreshDefault,
  },
  ktp: {
    key: 'ktp',
    title: 'Transporto priemonė',
    refresh: TurtasRefreshDefault,
  },
  traktorius: {
    key: 'traktorius',
    title: 'Traktorius ar kita mašina',
    refresh: TurtasRefreshDefault,
  },
  laivelis: {
    key: 'laivelis',
    title: 'Vidaus vandenų transporto priemonė',
    refresh: TurtasRefreshDefault,
  },
  vagonas: {
    key: 'vagonas',
    title: 'Geležinkelių riedmuo',
    refresh: TurtasRefreshDefault,
  },
  ginklas: {
    key: 'ginklas',
    title: 'Ginklai',
    refresh: TurtasRefreshDefault,
  },
  prekes_zenklas: {
    key: 'prekes_zenklas',
    title: 'Prekių ženklas',
    refresh: TurtasRefreshDefault,
  },
  kitas: {
    key: 'kitas',
    title: 'Kita',
    refresh: TurtasRefreshDefault,
  },
  imone: {
    key: 'imone',
    title: 'Įmonė',
    refresh: TurtasRefreshDefault,
  },
  banko_saskaita: {
    key: 'banko_saskaita',
    title: 'Lėšos banko sąskaitoje',
    refresh: TurtasRefreshDefault,
  },
  dizainas: {
    key: 'dizainas',
    title: 'Dizainas',
    refresh: TurtasRefreshDefault,
  },
  patentas: {
    key: 'patentas',
    title: 'Patentas',
    refresh: TurtasRefreshDefault,
  },
  ntr: {
    key: 'ntr',
    title: 'Nekilnojamasis turtas (NTR objektas)',
    refresh: TurtasRefreshDefault,
  },
  busimas_ntr: {
    key: 'ntr',
    title: 'Būsimas nekilnojamasis turtas',
    refresh: TurtasRefreshDefault,
  },
  kita_turtine_teise: {
    key: 'ntr',
    title: 'Turtinė teisė',
    refresh: TurtasRefreshDefault,
  },
}

const TEIKEJASTEKSTAS = {
  notaras: {
    teikejas: 'Duomenų teikėjas',
    vardas: 'Vardas',
    pavarde: 'Pavardė',
    pareigos: 'Pareigos',
    kontora: 'Notaro biuro pavadinimas',
    adresas: 'Notaro biuro adresas',

    teikejasTooltip: 'Duomenų teikėjas. Notaras. Duomenų teikėjas',
    vardasTooltip: 'Duomenų teikėjas. Notaras. Vardas',
    pavardeTooltip: 'Duomenų teikėjas. Notaras. Pavardė',
    pareigosTooltip: 'Duomenų teikėjas. Notaras. Pareigos',
    kontoraTooltip: 'Duomenų teikėjas. Notaras. Notaro biuro pavadinimas',
    adresasTooltip: 'Duomenų teikėjas. Notaras. Notaro biuro adresas',
  },
  antstolis: {
    teikejas: 'Duomenų teikėjas',
    vardas: 'Vardas',
    pavarde: 'Pavardė',
    pareigos: 'Pareigos',
    kontora: 'Antstolio kontoros pavadinimas',
    adresas: 'Antstolio kontoros adresas',

    teikejasTooltip: 'Duomenų teikėjas. Antstolis. Duomenų teikėjas',
    vardasTooltip: 'Duomenų teikėjas. Antstolis. Vardas',
    pavardeTooltip: 'Duomenų teikėjas. Antstolis. Pavardė',
    pareigosTooltip: 'Duomenų teikėjas. Antstolis. Pareigos',
    kontoraTooltip:
      'Duomenų teikėjas. Antstolis. Antstolio kontoros pavadinimas',
    adresasTooltip: 'Duomenų teikėjas. Antstolis. Antstolio kontoros adresas',
  },
  kita: {
    teikejas: 'Duomenų teikėjas',
    vardas: 'Vardas',
    pavarde: 'Pavardė',
    pareigos: 'Pareigos',
    kontora: 'Pavadinimas',
    adresas: 'Adresas',

    teikejasTooltip: 'Duomenų teikėjas. Fizinis/Juridinis. Duomenų teikėjas',
    vardasTooltip: 'Duomenų teikėjas. Fizinis/Juridinis. Vardas',
    pavardeTooltip: 'Duomenų teikėjas. Fizinis/Juridinis. Pavardė',
    pareigosTooltip: 'Duomenų teikėjas. Fizinis/Juridinis. Pareigos',
    kontoraTooltip: 'Duomenų teikėjas. Fizinis/Juridinis. Pavadinimas',
    adresasTooltip: 'Duomenų teikėjas. Fizinis/Juridinis. Adresas',
  },
}

const PRIEVOLETEKSTAS = {
  'sutartinis-hipoteka': {
    tab: 'Prievolės',
    title: 'Sutartine hipoteka užtikrintos prievolės',
    add: 'Pridėti prievolę',
    modalTitle: 'Prievolė',
    tablePrievole: 'Prievolė',
    tableDydis: 'Prievolės dydis',
    labels: {
      paprastas: {
        name: 'Sutartine hipoteka užtikrinta prievolė',
        dydis: 'Dydis',
        dydisKreditoriui: 'Dydis',
        netesybos: '',
        atlyginimas:
          'Netesybų ir kreditoriaus nuostolių, patirtų dėl užtikrintos prievolės neįvykdymo ir (ar) netinkamo vykdymo kreditoriui atlyginimas, suma',
        terminasData: 'Prievolės įvykdymo termino data iki',
        terminas:
          'Prievolės įvykdymo terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka. Užtikrinta prievolė',
        dydisTooltip: 'Hipoteka. Prievolė. Sutartinė hipoteka. Dydis',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka. Dydis',
        netesybosTooltip: 'Hipoteka. Prievolė. Sutartinė hipoteka. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka. Termino data',
        terminasTooltip: 'Hipoteka. Prievolė. Sutartinė hipoteka. Terminas',
      },
      maksimalus: {
        name: 'Sutartine hipoteka užtikrinta maksimali prievolė',
        dydis: 'Užtikrintos prievolės dydis',
        dydisKreditoriui: 'Maksimaliosios hipotekos dydis',
        netesybos:
          'Hipoteka yra užtikrinamas ir netesybų bei nuostolių, patirtų dėl užtikrintos prievolės netinkamo vykdymo ar neįvykdymo, kreditoriui atlyginimas',
        atlyginimas:
          'Netesybų ir kreditoriaus nuostolių, patirtų dėl užtikrintos prievolės neįvykdymo ir (ar) netinkamo vykdymo kreditoriui atlyginimas, suma',
        terminasData: 'Prievolės įvykdymo termino data iki',
        terminas:
          'Prievolės įvykdymo terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka maksimalioji. Užtikrinta prievolė',
        dydisTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka maksimalioji. Dydis',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka maksimalioji. Dydis kreditoriui',
        netesybosTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka maksimalioji. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka maksimalioji. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka maksimalioji. Termino data',
        terminasTooltip:
          'Hipoteka. Prievolė. Sutartinė hipoteka maksimalioji. Terminas',
      },
    },
  },
  'sutartinis-ikeitimas': {
    tab: 'Prievolės',
    title: 'Sutartiniu įkeitimu užtikrintos prievolės',
    add: 'Pridėti prievolę',
    modalTitle: 'Prievolė',
    tablePrievole: 'Prievolė',
    tableDydis: 'Prievolės dydis',
    labels: {
      paprastas: {
        name: 'Sutartiniu įkeitimu užtikrinta prievolė',
        dydis: 'Dydis',
        dydisKreditoriui: 'Dydis',
        netesybos: '',
        atlyginimas:
          'Netesybų ir kreditoriaus nuostolių, patirtų dėl užtikrintos prievolės neįvykdymo ir (ar) netinkamo vykdymo kreditoriui atlyginimas, suma',
        terminasData: 'Prievolės įvykdymo termino data iki',
        terminas:
          'Prievolės įvykdymo terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas. Užtikrinta prievolė',
        dydisTooltip: 'Hipoteka. Prievolė. Sutartinis įkeitimas. Dydis',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas. Dydis',
        netesybosTooltip: 'Hipoteka. Prievolė. Sutartinis įkeitimas. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas. Termino data',
        terminasTooltip: 'Hipoteka. Prievolė. Sutartinis įkeitimas. Terminas',
      },
      maksimalus: {
        name: 'Sutartiniu įkeitimu užtikrinta maksimali prievolė',
        dydis: 'Užtikrintos prievolės dydis',
        dydisKreditoriui: 'Maksimaliojo įkeitimo dydis',
        netesybos:
          'Įkeitimu yra užtikrinamas ir netesybų bei nuostolių, patirtų dėl užtikrintos prievolės netinkamo vykdymo ar neįvykdymo, kreditoriui atlyginimas',
        atlyginimas:
          'Netesybų ir kreditoriaus nuostolių, patirtų dėl užtikrintos prievolės neįvykdymo ir (ar) netinkamo vykdymo kreditoriui atlyginimas, suma',
        terminasData: 'Prievolės įvykdymo termino data iki',
        terminas:
          'Prievolės įvykdymo terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas maksimalusis. Užtikrinta prievolė',
        dydisTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas maksimalusis. Dydis',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas maksimalusis. Dydis kreditoriui',
        netesybosTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas maksimalusis. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas maksimalusis. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas maksimalusis. Termino data',
        terminasTooltip:
          'Hipoteka. Prievolė. Sutartinis įkeitimas maksimalusis. Terminas',
      },
    },
  },
  'priverstinis-hipoteka': {
    tab: 'Reikalavimai',
    title: 'Priverstine hipoteka užtikrinti reikalavimai',
    add: 'Pridėti reikalavimą',
    modalTitle: 'Reikalavimas',
    tablePrievole: 'Reikalavimai',
    tableDydis: 'Reikalavimo suma',
    labels: {
      paprastas: {
        name: 'Priverstine hipoteka užtikrinti reikalavimai',
        dydis: 'Reikalavimo suma',
        dydisKreditoriui: 'Reikalavimo suma',
        netesybos: '',
        atlyginimas: '',
        terminasData: 'Priverstinės hipotekos termino data iki',
        terminas:
          'Priverstinės hipotekos terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka. Užtikrinti reikalavimai',
        dydisTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka. Reikalavimo suma',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka. Reikalavimo suma',
        netesybosTooltip: 'Hipoteka. Prievolė. Priverstinė hipoteka. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka. Termino data',
        terminasTooltip: 'Hipoteka. Prievolė. Priverstinė hipoteka. Terminas',
      },
      maksimalus: {
        name: 'Priverstine hipoteka užtikrinta maksimali prievolė',
        dydis: 'Reikalavimo suma',
        dydisKreditoriui: 'Reikalavimo suma',
        netesybos: '',
        atlyginimas: '',
        terminasData: 'Priverstinės hipotekos termino data iki',
        terminas:
          'Priverstinės hipotekos terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka maksimalioji. Užtikrinti reikalavimai',
        dydisTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka maksimalioji. Reikalavimo suma',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka maksimalioji. Reikalavimo suma',
        netesybosTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka maksimalioji. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka maksimalioji. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka maksimalioji. Termino data',
        terminasTooltip:
          'Hipoteka. Prievolė. Priverstinė hipoteka maksimalioji. Terminas',
      },
    },
  },
  'priverstinis-ikeitimas': {
    tab: 'Reikalavimai',
    title: 'Priverstiniu įkeitimu užtikrinti reikalavimai',
    add: 'Pridėti reikalavimą',
    modalTitle: 'Reikalavimas',
    tablePrievole: 'Reikalavimai',
    tableDydis: 'Reikalavimo suma',
    labels: {
      paprastas: {
        name: 'Priverstiniu įkeitimu užtikrinti reikalavimai',
        dydis: 'Reikalavimo suma',
        dydisKreditoriui: 'Reikalavimo suma',
        netesybos: '',
        atlyginimas: '',
        terminasData: 'Priverstinio įkeitimo termino data iki',
        terminas:
          'Priverstinio įkeitimo terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas. Užtikrinti reikalavimai',
        dydisTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas. Reikalavimo suma',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas. Reikalavimo suma',
        netesybosTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas. Termino data',
        terminasTooltip: 'Hipoteka. Prievolė. Priverstinis įkeitimas. Terminas',
      },
      maksimalus: {
        name: 'Priverstiniu įkeitimu užtikrinta maksimali prievolė',
        dydis: 'Reikalavimo suma',
        dydisKreditoriui: 'Reikalavimo suma',
        netesybos: '',
        atlyginimas: '',
        terminasData: 'Priverstinio įkeitimo termino data iki',
        terminas:
          'Priverstinio įkeitimo terminas (aplinkybė ar įvykis, kuris neišvengiamai turi įvykti)',

        nameTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas maksimalusis. Užtikrinti reikalavimai',
        dydisTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas maksimalusis. Reikalavimo suma',
        dydisKreditoriuiTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas maksimalusis. Reikalavimo suma',
        netesybosTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas maksimalusis. Netesybos',
        atlyginimasTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas maksimalusis. Atlyginimas',
        terminasDataTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas maksimalusis. Termino data',
        terminasTooltip:
          'Hipoteka. Prievolė. Priverstinis įkeitimas maksimalusis. Terminas',
      },
    },
  },
}

const SALYGINISTEKSTAS = {
  hipoteka: {
    tab: 'Sąlyginės hipotekos sąlygos',
    title: 'Sąlyginės hipotekos sąlygos',
    button: 'Pasirinkite hipotekos rūšį',
    isigaliojimo_salyga:
      'Sąlyga, su kuria siejamas sutartinės hipotekos įsigaliojimas',
    galiojimo_pabaiga: 'Sąlyga, kuriai esant baigiasi hipotekos galiojimas',
    isigaliojusi: 'Sąlyginės hipotekos sąlyga įsigaliojusi',
    aprasymas: 'Sąlygos aprašymas',
    salyga_ivykdyta:
      'Informacija, kad sąlyginės hipotekos įsigaliojimo sąlyga yra įvykdyta ir hipoteka yra įsigaliojusi',

    isigaliojimo_salygaTooltip:
      'Hipoteka. Sąlyginė hipoteka. Įsigaliojimo sąlyga',
    galiojimo_pabaigaTooltip: 'Hipoteka. Sąlyginė hipoteka. Galiojimo pabaiga',
    aprasymasTooltip: 'Hipoteka. Sąlyginė hipoteka. Sąlygos aprašymas',
    isigaliojusiTooltip: 'Hipoteka. Sąlyginė hipoteka. Įsigaliojusi',
    salyga_ivykdytaTooltip: 'Hipoteka. Sąlyginė hipoteka. Sąlyga įvykdyta',
  },
  ikeitimas: {
    tab: 'Sąlyginio įkeitimo sąlygos',
    title: 'Sąlyginio įkeitimo sąlygos',
    button: 'Pasirinkite įkeitimo rūšį',
    isigaliojimo_salyga:
      'Sąlyga, su kuria siejamas sąlyginio įkeitimo galiojimas',
    galiojimo_pabaiga: 'Sąlyga, kuriai esant baigiasi įkeitimo galiojimas',
    aprasymas: 'Sąlygos aprašymas',
    isigaliojusi: 'Sąlyginio įkeitimo sąlyga įsigaliojusi',
    salyga_ivykdyta:
      'Informacija, kad sąlyginio įkeitimo įsigaliojimo sąlyga yra įvykdyta ir įkeitimas yra įsigaliojęs',

    isigaliojimo_salygaTooltip:
      'Hipoteka. Sąlyginis įkeitimas. Įsigaliojimo sąlyga',
    galiojimo_pabaigaTooltip:
      'Hipoteka. Sąlyginis įkeitimas. Galiojimo pabaiga',
    aprasymasTooltip: 'Hipoteka. Sąlyginis įkeitimas. Sąlygos aprašymas',
    isigaliojusiTooltip: 'Hipoteka. Sąlyginis įkeitimas. Įsigaliojusi',
    salyga_ivykdytaTooltip: 'Hipoteka. Sąlyginis įkeitimas. Sąlyga įvykdyta',
  },
}

const KITAINFOTEKSTAS = {
  'sutartinis-hipoteka': {
    nustatymo_pagrindas: '-',
    palukanu_aprasymas: 'Metinių palūkanų dydžio aprašymas',
    palukanos: 'Palūkanos procentais',
    varzytiniu_eile: 'Hipotekos objektų pardavimo varžytynėse eilė',
    isigaliojimo_salyga:
      'Sąlyga, su kuria siejamas sutartinės hipotekos įsigaliojimas',
    isigaliojimo_momentas: 'Hipotekos įsigaliojimo momentas',
    salyga_ivykdyta:
      'Informacija, kad sąlyginės hipotekos įsigaliojimo sąlyga yra įvykdyta ir hipoteka yra įsigaliojusi',
    reikalavimo_terminas:
      'Terminas, nuo kurio kreditorius gali reikalauti vykdyti įsipareigojimą',
    perduodamas_kreditoriui:
      'Įkeitimo objektas perduodamas kreditoriui, trečiajam asmeniui',
    kiti_sandoriai: 'Kiti hipotekos (įkeitimo) sandoriai',
    sudarymo_data: 'Sandorio sudarymo data',
    sudarymo_laikas: 'Sandorio sudarymo laikas',
    sudarymo_vieta: 'Sandorio sudarymo vieta',

    nustatymo_pagrindasTooltip: '-',
    palukanu_aprasymasTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Palūkanų aprašymas',
    palukanosTooltip: 'Hipoteka. Kita info. Sutartinė hipoteka. Palūkanos',
    varzytiniu_eileTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Varžytinių eilė',
    isigaliojimo_salygaTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Įsigaliojimo sąlyga',
    isigaliojimo_momentasTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Įsigaliojimo momentas',
    salyga_ivykdytaTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Sąlyga įvykdyta',
    reikalavimo_terminasTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Reikalavimo terminas',
    perduodamas_kreditoriuiTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Perduodamas kreditoriui',
    kiti_sandoriaiTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Kiti sandoriai',
    sudarymo_dataTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Sudarymo data',
    sudarymo_laikasTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Sudarymo laikas',
    sudarymo_vietaTooltip:
      'Hipoteka. Kita info. Sutartinė hipoteka. Sudarymo vieta',
  },
  'priverstinis-hipoteka': {
    nustatymo_pagrindas: 'Priverstinės hipotekos nustatymo pagrindas',
    palukanu_aprasymas: 'Delspinigių (palūkanų) aprašymas',
    palukanos: 'Delspinigiai (palūkanos)',
    varzytiniu_eile: 'Hipotekos objektų pardavimo varžytynėse eilė',
    isigaliojimo_salyga:
      'Sąlyga, su kuria siejamas sutartinės hipotekos įsigaliojimas',
    isigaliojimo_momentas: 'Hipotekos įsigaliojimo momentas',
    salyga_ivykdyta:
      'Informacija, kad sąlyginės hipotekos įsigaliojimo sąlyga yra įvykdyta ir hipoteka yra įsigaliojusi',
    reikalavimo_terminas:
      'Terminas, nuo kurio kreditorius gali reikalauti vykdyti įsipareigojimą',
    perduodamas_kreditoriui:
      'Įkeitimo objektas perduodamas kreditoriui, trečiajam asmeniui',
    kiti_sandoriai: 'Kiti hipotekos (įkeitimo) sandoriai',
    sudarymo_data: 'Nustatymo data',
    sudarymo_laikas: 'Nustatymo laikas',
    sudarymo_vieta: 'Nustatymo vieta',

    nustatymo_pagrindasTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Nustatymo pagrindas',
    palukanu_aprasymasTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Palūkanų aprašymas',
    palukanosTooltip: 'Hipoteka. Kita info. Priverstinė hipoteka. Palūkanos',
    varzytiniu_eileTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Varžytinių eilė',
    isigaliojimo_salygaTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Įsigaliojimo sąlyga',
    isigaliojimo_momentasTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Įsigaliojimo momentas',
    salyga_ivykdytaTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Sąlyga įvykdyta',
    reikalavimo_terminasTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Reikalavimo terminas',
    perduodamas_kreditoriuiTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Perduodamas kreditoriui',
    kiti_sandoriaiTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Kiti sandoriai',
    sudarymo_dataTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Sudarymo data',
    sudarymo_laikasTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Sudarymo laikas',
    sudarymo_vietaTooltip:
      'Hipoteka. Kita info. Priverstinė hipoteka. Sudarymo vieta',
  },
  'sutartinis-ikeitimas': {
    nustatymo_pagrindas: '-',
    palukanu_aprasymas: 'Metinių palūkanų dydžio aprašymas',
    palukanos: 'Palūkanos procentais',
    varzytiniu_eile: 'Išieškojimo iš įkeitimo objektų tvarka',
    isigaliojimo_salyga:
      'Sąlyga, su kuria siejamas sąlyginio įkeitimo galiojimas',
    isigaliojimo_momentas: 'Įkeitimo įsigaliojimo momentas',
    salyga_ivykdyta:
      'Informacija, kad sąlyginio įkeitimo įsigaliojimo sąlyga yra įvykdyta ir įkeitimas yra įsigaliojęs',
    reikalavimo_terminas:
      'Terminas, nuo kurio kreditorius gali reikalauti vykdyti įsipareigojimą',
    perduodamas_kreditoriui:
      'Įkeitimo objektas perduodamas kreditoriui, trečiajam asmeniui',
    kiti_sandoriai: 'Kiti hipotekos (įkeitimo) sandoriai',
    sudarymo_data: 'Sandorio sudarymo data',
    sudarymo_laikas: 'Sandorio sudarymo laikas',
    sudarymo_vieta: 'Sandorio sudarymo vieta',

    nustatymo_pagrindasTooltip: '-',
    palukanu_aprasymasTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Palūkanų aprašymas',
    palukanosTooltip: 'Hipoteka. Kita info. Sutartinis įkeitimas. Palūkanos',
    varzytiniu_eileTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Varžytinių eilė',
    isigaliojimo_salygaTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Įsigaliojimo sąlyga',
    isigaliojimo_momentasTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Įsigaliojimo momentas',
    salyga_ivykdytaTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Sąlyga įvykdyta',
    reikalavimo_terminasTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Reikalavimo terminas',
    perduodamas_kreditoriuiTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Perduodamas kreditoriui',
    kiti_sandoriaiTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Kiti sandoriai',
    sudarymo_dataTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Sudarymo data',
    sudarymo_laikasTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Sudarymo laikas',
    sudarymo_vietaTooltip:
      'Hipoteka. Kita info. Sutartinis įkeitimas. Sudarymo vieta',
  },
  'priverstinis-ikeitimas': {
    nustatymo_pagrindas: 'Priverstinio įkeitimo nustatymo pagrindas',
    palukanu_aprasymas: 'Delspinigių (palūkanų) aprašymas',
    palukanos: 'Delspinigiai (palūkanos)',
    varzytiniu_eile: 'Išieškojimo iš įkeitimo objektų tvarka',
    isigaliojimo_salyga:
      'Sąlyga, su kuria siejamas sąlyginio įkeitimo galiojimas',
    isigaliojimo_momentas: 'Įkeitimo įsigaliojimo momentas',
    salyga_ivykdyta:
      'Informacija, kad sąlyginio įkeitimo įsigaliojimo sąlyga yra įvykdyta ir įkeitimas yra įsigaliojęs',
    reikalavimo_terminas:
      'Terminas, nuo kurio kreditorius gali reikalauti vykdyti įsipareigojimą',
    perduodamas_kreditoriui:
      'Įkeitimo objektas perduodamas kreditoriui, trečiajam asmeniui',
    kiti_sandoriai: 'Kiti įkeitimo sandoriai',
    sudarymo_data: 'Nustatymo data',
    sudarymo_laikas: 'Nustatymo laikas',
    sudarymo_vieta: 'Nustatymo vieta',

    nustatymo_pagrindasTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Nustatymo pagrindas',
    palukanu_aprasymasTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Palūkanų aprašymas',
    palukanosTooltip: 'Hipoteka. Kita info. Priverstinis įkeitimas. Palūkanos',
    varzytiniu_eileTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Varžytinių eilė',
    isigaliojimo_salygaTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Įsigaliojimo sąlyga',
    isigaliojimo_momentasTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Įsigaliojimo momentas',
    salyga_ivykdytaTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Sąlyga įvykdyta',
    reikalavimo_terminasTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Reikalavimo terminas',
    perduodamas_kreditoriuiTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Perduodamas kreditoriui',
    kiti_sandoriaiTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Kiti sandoriai',
    sudarymo_dataTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Sudarymo data',
    sudarymo_laikasTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Sudarymo laikas',
    sudarymo_vietaTooltip:
      'Hipoteka. Kita info. Priverstinis įkeitimas. Sudarymo vieta',
  },
}

const ASMENYSROLES = {
  teikejas: 'teikejas',
  tvirtintojas: 'tvirtintojas',
  skolininkas: 'skolininkas',
  davejas: 'davejas',
  davejasHR: 'ikaito_davejas_hr',
  kreditorius: 'kreditorius',
  nvi_kreditorius: 'nvi_kreditorius',
  turtas_davejas: 'turto_davejas',
  busimas_savininkas: 'busimas_savininkas',
  turtas_gavejas: 'turto_gavejas',
  informuojamas: 'informuojamas',
  atstovas: 'atstovas',
  sutartis: 'sutartis',
  sutartis_davejas: 'sutartis_davejas',
  sutartis_gavejas: 'sutartis_gavejas',
  administratorius: 'administratorius',
  perleidzia: 'perleidzia',
  priima: 'priima',
}

const SUTARTISROLESTEKSTAS = {
  atpirkimas: {
    sutartis_davejas: 'Pardavėjas',
    sutartis_gavejas: 'Pirkėjas',
    sutartis_davejasTooltip: 'Pardavėjas',
    sutartis_gavejasTooltip: 'Pirkėjas',
  },
  issimoketinas: {
    sutartis_davejas: 'Pardavėjas',
    sutartis_gavejas: 'Pirkėjas',
    sutartis_davejasTooltip: 'Modalas asmuo. Sutarties šalis. Pardavėjas',
    sutartis_gavejasTooltip: 'Modalas asmuo. Sutarties šalis. Pirkėjas',
  },
  lizingas: {
    sutartis_davejas: 'Davėjas',
    sutartis_gavejas: 'Gavėjas',
    sutartis_davejasTooltip: 'Modalas asmuo. Sutarties šalis. Davėjas',
    sutartis_gavejasTooltip: 'Modalas asmuo. Sutarties šalis. Gavėjas',
  },
  nuoma: {
    sutartis_davejas: 'Nuomotojas',
    sutartis_gavejas: 'Nuomininkas',
    sutartis_davejasTooltip: 'Modalas asmuo. Sutarties šalis. Nuomotojas',
    sutartis_gavejasTooltip: 'Modalas asmuo. Sutarties šalis. Nuomininkas',
  },
  panauda: {
    sutartis_davejas: 'Panaudos davėjas',
    sutartis_gavejas: 'Panaudos gavėjas',
    sutartis_davejasTooltip: 'Modalas asmuo. Sutarties šalis. Panaudos davėjas',
    sutartis_gavejasTooltip: 'Modalas asmuo. Sutarties šalis. Panaudos gavėjas',
  },
}

const OBJEKTASBUSENA = {
  rengiamas: {
    key: 'rengiamas',
    title: 'Rengiamas',
  },
  patvirtinti: {
    key: 'patvirtinti',
    title: 'Patvirtinti',
  },
  laukia_patvirtinimo: {
    key: 'laukia_patvirtinimo',
    title: 'Laukia patvirtinimo',
  },
  laukia_apmokejimo: {
    key: 'laukia_apmokejimo',
    title: 'Laukia apmokėjimo',
  },
  perduotas: {
    key: 'perduotas',
    title: 'Perduotas',
  },
  grazintas: {
    key: 'grazintas',
    title: 'Grąžintas',
  },
  nepatikslintas: {
    key: 'nepatikslintas',
    title: 'Nepatikslintas',
  },
  iregistruotas: {
    key: 'iregistruotas',
    title: 'Įregistruotas',
  },
  atmestas: {
    key: 'atmestas',
    title: 'Atmestas',
  },
  nutrauktas: {
    key: 'nutrauktas',
    title: 'Nutrauktas',
  },
}

const BUSENATEKSTAS = {
  rengti: {
    title: 'Grąžinimas',
    message:
      'Dokumento pasirašymas bus atšauktas ir dokumentas grąžintas duomenų teikėjui. Ar norite tęsti?',
    messageCancel: 'Grąžinimas negalimas, aptikta kritinių klaidų.',
    checkErrors: false,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  perduoti: {
    title: 'Perdavimas',
    message: 'Ar norite duomenis perduoti registrui?',
    messageCancel: 'Perdavimas negalimas, aptikta kritinių klaidų.',
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  patvirtinti: {
    title: 'Patvirtinimas',
    message: 'Ar norite patvirtinti duomenis?',
    messageCancel: 'Perdavimas negalimas, aptikta kritinių klaidų.',
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  moketi: {
    title: 'Mokėjimas',
    message: 'Sumokėjus už paslaugas pranešimas bus perduotas registrui',
    messageCancel: 'Perdavimas negalimas, aptikta kritinių klaidų.',
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  pasirasyti: {
    title: 'Pasirašymas',
    message: 'Ar tikrai norite pasirašyti?',
    messageCancel: 'Pasirašymas negalimas, aptikta kritinių klaidų.',
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  grazinti: {
    title: 'Grąžinimas tikslinti',
    message: 'Ar norite duomenis grąžinti tikslinti?',
    messageCancel: '',
    checkErrors: false,
    terminas: 'Grąžinimo tikslinti terminas',
    priezastis: 'Grąžinimo tikslinti priežastis',
    motyvas: 'Sprendimo motyvai',
    pagrindas:
      'Sprendimą pagrindžiančios procesinės ir materialinės teisės normos',
    aprasymas: 'Grąžinimo tikslinti priežasties aprašymas',
    atmetimasAprasymas: '',
    terminoPraleidimoPriezastis: 'Termino praleidimo priežastis',

    terminasTooltip: 'Modalas būsena. Grąžintas. Terminas',
    priezastisTooltip: 'Modalas būsena. Grąžintas. Priežastis',
    motyvasTooltip: 'Modalas būsena. Grąžintas. Motyvas',
    pagrindasTooltip: 'Modalas būsena. Grąžintas. Pagrindas',
    aprasymasTooltip: 'Modalas būsena. Grąžintas. Aprašymas',
    atmetimasAprasymasTooltip: '',
    terminoPraleidimoPriezastisTooltip:
      'Modalas būsena. Grąžintas. Termino praleidimo priežastis',
  },
  iregistruoti: {
    title: 'Registravimas',
    message: 'Ar norite duomenis įrašyti į registrą?',
    messageCancel: 'Įregistravimas negalimas, aptikta kritinių klaidų.',
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',
    terminoPraleidimoPriezastis: 'Termino praleidimo priežastis',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
    terminoPraleidimoPriezastisTooltip:
      'Modalas būsena. Įregistruotas. Termino praleidimo priežastis',
  },
  atmesti: {
    title: 'Atmetimas',
    message: 'Ar norite duomenis atmesti?',
    messageCancel: '',
    checkErrors: false,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    motyvas: 'Sprendimo motyvai',
    pagrindas:
      'Sprendimą pagrindžiančios procesinės ir materialinės teisės normos',
    atmetimasAprasymas: 'Atmetimo priežasties aprašymas',
    terminoPraleidimoPriezastis: 'Termino praleidimo priežastis',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    motyvasTooltip: 'Modalas būsena. Atmestas. Motyvas',
    pagrindasTooltip: 'Modalas būsena. Atmestas. Pagrindas',
    atmetimasAprasymasTooltip: 'Modalas būsena. Atmestas. Aprašymas',
    terminoPraleidimoPriezastisTooltip:
      'Modalas būsena. Atmestas. Termino praleidimo priežastis',
  },
}

const ZURNALASBUSENA = {
  suformuotas: 'suformuotas',
  nesuformuotas: 'nesuformuotas',
  pateiktas: 'pateiktas',
}

const BYLATIPAS = {
  default: {
    title: '',
    icon: 'mdi-file-outline',
    fileName: '',
  },
  preview_pranesimas: {
    title: 'Registro pranešimas (peržiūra)',
    icon: 'mdi-file-check-outline',
    fileName: 'pranesimas',
  },
  preview_dokumentas: {
    title: 'Įregistravimo dokumentas (peržiūra)',
    icon: 'mdi-file-document-outline',
    fileName: 'dokumentas',
  },
  pranesimas: {
    title: 'Registro pranešimas',
    icon: 'mdi-file-check-outline',
    fileName: 'registro pranesimas',
  },
  dokumentas: {
    title: 'Įregistravimo dokumentas',
    icon: 'mdi-file-document-outline',
    fileName: 'iregistravimo dokumentas',
  },
  siunciami: {
    title: 'Registro pranešimas',
    icon: 'mdi-file-outline',
    fileName: 'registro pranesimas',
  },
}

const SAVITARNAOBJEKTAS = {
  'savitarna-ikeitimas': {
    title: 'Įkeitimas',
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-hipoteka': {
    title: 'Hipoteka',
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis': {
    title: 'Sutartis',
    role: ['EL_JA', 'EL_FA'],
  },
}

const SAVITARNAVEIKSMAS = {
  // savitarna ikeitimas
  'savitarna-ikeitimas-perziura': {
    title: 'Peržiūrėti',
    icon: 'mdi-eye-check',
    group: 1,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-ikeitimas-redagavimas': {
    title: 'Redaguoti',
    group: 1,
    icon: 'mdi-pencil-outline',
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-ikeitimas-pasirasymas': {
    title: 'Pasirašyti',
    icon: 'mdi-check-decagram-outline',
    group: 2,
    primary: true,
    button: true,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-ikeitimas-mokejimas': {
    title: 'Mokėti',
    group: 2,
    primary: true,
    button: true,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-ikeitimas-pakeitimas': {
    title: 'Pakeisti sandorį',
    icon: 'mdi-clipboard-flow-outline',
    fail:
      'Nėra įregistruotų įkeitimų, kuriems pakeitimus galėtumėte atlikti savitarnoje',
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-ikeitimas-pakeitimas-teikiamas': {
    title: 'Pranešti apie pakeitimą',
    icon: 'mdi-clipboard-flow-outline',
    fail:
      'Nėra įregistruotų įkeitimų, kuriems pakeitimus galėtumėte atlikti savitarnoje',
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-ikeitimas-pabaiga': {
    title: 'Išregistruoti',
    icon: 'mdi-clipboard-remove-outline',
    fail: 'Nėra įregistruotų įkeitimų, kurių šalis esate Jūs',
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-ikeitimas-salinimas': {
    title: 'Šalinti',
    group: 1,
    icon: 'mdi-delete-outline',
    role: ['EL_JA', 'EL_FA'],
  },

  // savitarna hipoteka
  'savitarna-hipoteka-perziura': {
    title: 'Peržiūrėti',
    icon: 'mdi-eye-check',
    group: 1,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-hipoteka-redagavimas': {
    title: 'Redaguoti',
    icon: 'mdi-pencil-outline',
    group: 1,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-hipoteka-pasirasymas': {
    title: 'Pasirašyti',
    icon: 'mdi-check-decagram-outline',
    primary: true,
    button: true,
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-hipoteka-mokejimas': {
    title: 'Mokėti',
    group: 2,
    primary: true,
    button: true,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-hipoteka-pabaiga': {
    title: 'Išregistruoti',
    icon: 'mdi-clipboard-remove-outline',
    fail: 'Nėra įregistruotų hipotekų, kurių šalis esate Jūs',
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-hipoteka-salinimas': {
    title: 'Šalinti',
    icon: 'mdi-delete-outline',
    group: 1,
    role: ['EL_JA', 'EL_FA'],
  },

  // savitarna sutartis
  'savitarna-sutartis-perziura': {
    title: 'Peržiūrėti',
    icon: 'mdi-eye-check',
    group: 1,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-redagavimas': {
    title: 'Redaguoti',
    icon: 'mdi-pencil-outline',
    group: 1,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-pasirasymas': {
    title: 'Pasirašyti',
    icon: 'mdi-check-decagram-outline',
    primary: true,
    button: true,
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-mokejimas': {
    title: 'Mokėti',
    group: 2,
    primary: true,
    button: true,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-pakeitimas': {
    title: 'Pakeisti',
    icon: 'mdi-file-document-multiple-outline',
    fail: 'Nėra įregistruotų sutarčių, kurių šalis esate Jūs',
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-pabaiga': {
    title: 'Išregistruoti',
    icon: 'mdi-file-remove-outline',
    fail: 'Nėra įregistruotų sutarčių, kurių šalis esate Jūs',
    group: 2,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-salinimas': {
    title: 'Šalinti',
    icon: 'mdi-delete-outline',
    group: 1,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-pageidavimas': {
    title: 'Pageidauti pasinaudoti atpirkimo teise',
    icon: 'mdi-file-export-outline',
    fail:
      'Nėra įregistruotų sutarčių, kurioms galite įregistruoti pageidavimą pasinaudoti atpirkimo teise',
    group: 3,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-atsaukimas': {
    title: 'Atšaukti pageidavimą pasinaudoti atpirkimo teise',
    icon: 'mdi-file-lock-outline',
    fail:
      'Nėra įregistruotų sutarčių, kurioms galite įregistruoti pageidavimo pasinaudoti atpirkimo teise atšaukimą',
    group: 3,
    role: ['EL_JA', 'EL_FA'],
  },
  'savitarna-sutartis-neisregistruoti': {
    title: 'Prašyti neišregistruoti sutarties automatiškai',
    icon: 'mdi-file-edit-outline',
    fail:
      'Nėra įregistruotų sutarčių, kurioms galite įregistruoti prašymą neišregistruoti sutartis automatiškai',
    group: 3,
    role: ['EL_JA', 'EL_FA'],
  },
}

export default {
  hipotekaTipas: HIPOTEKATIPAS,
  pranesimasRusis: PRANESIMASRUSIS,
  pranesimasPagrindas: PRANESIMASPAGRINDAS,
  asmenysRoles: ASMENYSROLES,
  sutartisRolesTekstas: SUTARTISROLESTEKSTAS,
  turtasTekstas: TURTASTEKSTAS,
  turtasKitasTitle: TURTASKITASTITLE,
  turtasTipas: TURTASTIPAS,
  TurtasRefreshTable: TURTASREFRESHTABLE,
  teikejasTekstas: TEIKEJASTEKSTAS,
  prievoleTekstas: PRIEVOLETEKSTAS,
  salyginisTekstas: SALYGINISTEKSTAS,
  kitaInfoTekstas: KITAINFOTEKSTAS,
  objektasBusena: OBJEKTASBUSENA,
  zurnalasBusena: ZURNALASBUSENA,
  busenaTekstas: BUSENATEKSTAS,
  savitarnaObjektas: SAVITARNAOBJEKTAS,
  savitarnaVeiksmas: SAVITARNAVEIKSMAS,
}
